'use client';

export default function NotFound() {
  return (
    <div className="grid h-full place-items-center">
      <h2>Something went wrong!</h2>
    </div>
  );
}
